module.exports = __webpack_public_path__ + "img/home-back-two.996b335a.jpg";